/** Evita `NaN` em inputs `type="number"` vazios antes da validação Zod. */
export function numberInputValueAs(value: unknown): number | undefined {
  if (value === '' || value === null || value === undefined) return undefined;
  const num = typeof value === 'number' ? value : Number(value);
  return Number.isNaN(num) ? undefined : num;
}

/** Converte mensagens padrão do Zod (inglês) para PT-BR no feedback do formulário. */
export function translateZodFieldMessage(message?: string): string | undefined {
  if (!message) return undefined;
  const lower = message.toLowerCase();
  if (lower.includes('expected number') && lower.includes('nan')) {
    return 'Informe um número válido';
  }
  if (lower.includes('expected string') && lower.includes('nan')) {
    return 'Informe um valor válido';
  }
  if (lower.includes('invalid input')) {
    return 'Valor inválido';
  }
  return message;
}
